<template>
  <div class="outer-wrapper">
    <div v-if="currentEquipment.name">
      <van-nav-bar
        title="设备详情"
        fixed
      >
      </van-nav-bar>
      <van-cell :value="currentEquipment.equipnum+' '+currentEquipment.name" value-class="title-p" />
      <!-- <van-cell :value="''" value-class="sub-title-p" /> -->
      <van-cell
        title="设备状态"
        :value="currentEquipment.stat"
        value-class="prop-value"
        title-class="prop-title"
      />
      <van-cell
        title="使用状态"
        :value="currentEquipment.useStat"
        value-class="prop-value"
        title-class="prop-title"
      />
      <van-cell
        title="设备位置"
        :value="currentEquipment.position_name"
        value-class="prop-value"
        title-class="prop-title"
      />
      <van-cell
        title="保管人"
        :value="currentEquipment.keeper"
        value-class="prop-value"
        title-class="prop-title"
      />
      <van-cell title="设备使用记录" is-link @click="goUrl('TestOp')" />
      <van-cell title="期间核查记录" is-link @click="goUrl('PeriodCheck')" />
      <van-cell title="维护保养记录" is-link @click="goUrl('MaintainRecord')" />
      <van-cell title="检定校准记录" is-link @click="goUrl('CalibrationRecord')" />
      <van-cell title="操作指导书" is-link @click="goUrl('WorkInstruction')" />
    </div>
    <div v-else-if="!currentEquipment.name">
      <van-empty description="该设备信息已失效（设备变更...）" />
    </div>
    <div class="spin" v-else>
      <van-loading type="spinner" color="#1989fa" />
    </div>
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
//let authData = JSON.parse(localStorage.getItem("authData"));

export default {
  name: "equipmentInfo",
  components: {},
  props: {
    enid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      currentEquipment: {},
    };
  },
  watch: {},
  computed: {},
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$axios
        .post(this.$url + "/equipment", {
          userToken: userToken,
          ask_data: "equipmentTotalInfo",
          enid: this.enid,
        })
        .then((response) => {
          if (response.data.stat === "ok") {
            this.currentEquipment = response.data.res_record;
            this.currentEquipment.useStat = response.data.useStat;
          } else {
            this.$toast.fail("未找到数据！");
          }
        });
    },
    goUrl(value){
      location.href= "/equipment"+value+'/'+this.enid;
    }
  },
};
</script>
<style scoped>
.title-p {
  font-weight: 700;
  font-size: 0.9rem;
  text-align: center;
}
.sub-title-p {
  text-indent: 1.2rem;
  color: #999;
}

.prop-title {
  color: #999;
  font-size: 0.4rem;
}
.prop-value {
  color: #333;
  font-size: 0.7rem;
}
.spin {
  text-align: center;
  padding-top: 40%;
}

.sample-list-wrapper {
  text-align: center;
  width: 100%;
  word-break: break-all;
}

.sample-list-inner-wrapper {
  margin: 0.5rem 0.6rem;
}

.submit-b-wrapper {
  position: fixed;
  bottom: 0;
  display: flex;
  width: 100%;
}

.suspend-b {
  width: 6rem;
}

.record-value {
  text-indent: 1rem;
}
</style>